import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import MKBox from "components/MKBox";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/DefaultFooter";
import ContainerCard from "components/ContainerCard";

import Container from "@mui/material/Container";
import UserDataTable from "./sections/UserDataTable";
import UserCredits from "./sections/UserCredits";
import { useParams } from "react-router-dom";
import UserChatSessions from "./sections/UserChatSessions";
import { UserChatsProvider } from "./contexts/UserChatsContext";

function ChatsDatabase() {
  const { id } = useParams();

  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />
      <ContainerCard>
        <Container>
          <UserDataTable id={id} />
          <UserCredits id={id} />
          <UserChatsProvider>
            <UserChatSessions id={id} />
          </UserChatsProvider>
        </Container>
      </ContainerCard>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ChatsDatabase;
